class Select {
    constructor(element) {
        this.element = element;
        this.iconNotFound = "questionmark";
        this.selectActions = {
            Close: 0,
            CloseSelect: 1,
            First: 2,
            Last: 3,
            Next: 4,
            Open: 5,
            PageDown: 6,
            PageUp: 7,
            Previous: 8,
            Select: 9,
            Type: 10,
        };
        this.el = element;
        this.labelEl = element.querySelector('.form__label .label');
        this.comboEl = element.querySelector('[role=combobox]');
        this.comboElLabel = element.querySelector('.form__select-field-label .label');
        this.listboxEl = element.querySelector('[role=listbox]');
        this.comboElIcon = element.querySelector('.form__select-field-icon');
        this.selectedOption = element.querySelector('.form__select-option[aria-selected="true"]');
        this.optionDropdown = element.querySelector('.form__select-options');
        this.options = element.querySelectorAll('.form__select-option');
        this.hiddenInput = element.querySelector("#hidden-input-" + this.comboEl.id);
        this.options.forEach((option, index) => {
            option.addEventListener('click', (event) => {
                event.stopPropagation();
                this.onOptionClick(index);
            });
            option.addEventListener('mousedown', this.onOptionMouseDown.bind(this));
        })

        this.selectIsInInput = false;
        if (element.closest(".form__input")) {
            this.countryCodeMap = {};
            const parentInput = element.closest(".form__input");
            this.parentInput = parentInput;
            this.parentInputEl = parentInput.querySelector(".form__input-field");
            this.options = parentInput.querySelectorAll('.form__select-option');
            this.options.forEach((option, index) => {
                const countryCodeMatch = option.querySelector(".form__select-option-label").textContent.match(/\+\d+/);
                if (countryCodeMatch) {
                    const countryCode = countryCodeMatch[0];
                    this.countryCodeMap[index] = countryCode;
                }
            })

            this.selectIsInInput = true;

            this.parentInputEl.addEventListener('input', (e) => {
                this.selectCountryCodeOption(e.target.value);
            })
        }

        // data
        this.idBase = this.comboEl.id || 'combo';

        // state
        this.activeIndex = -1;
        this.open = false;
        this.searchString = '';
        this.searchTimeout = null;

        // init
        if (element && this.comboEl && this.listboxEl) {
            this.init();
        }

        window.addEventListener('resize', () => {
            this.updateListboxPosition();
            this.resizeTrigger();
        });
    }

    init() {
        if (!this.element.closest(".form__element--floating") || this.element.closest(".form__input--with-select")) {
            const textContent = this.selectedOption ? this.selectedOption.textContent : this.options[0].textContent;

            if (this.comboElIcon) {
                const iconPath = this.comboElIcon.dataset.iconPath + (this.selectedOption ? this.selectedOption.dataset.iconName : this.options[0].dataset.iconName) + ".svg";

                this.fetchSvg(iconPath).then(svg => {
                    if (svg) {
                        const iconEl = this.comboElIcon.querySelector(".icon");
                        iconEl.innerHTML = ""; // optional: clear existing content
                        iconEl.appendChild(svg);
                    }
                });
            }

            if (this.selectIsInInput) {
                this.appendCountryCode(textContent);
            }
            this.comboElLabel.innerHTML = textContent;

            const selectedIndex = [...this.options].findIndex(
                option => option.getAttribute('aria-selected') === 'true'
            );
            if (selectedIndex === 0) {
                this.setCurrentOption(this.options, 1);
                this.activeIndex = 1;
            } else {
                this.setCurrentOption(this.options, 0);
                this.activeIndex = 0;
            }

            this.hiddenInput.value = this.selectedOption?.dataset.value;
        }

        // add event listeners
        if (this.labelEl) {
            this.labelEl.addEventListener('click', this.onLabelClick.bind(this));
        }
        this.comboEl.addEventListener('blur', this.onComboBlur.bind(this));
        this.listboxEl.addEventListener('focusout', this.onComboBlur.bind(this));
        this.comboEl.addEventListener('click', this.onComboClick.bind(this));
        this.comboEl.addEventListener('keydown', this.onComboKeyDown.bind(this));

        this.resizeTrigger();
    };

    resizeTrigger() {
        // Create a temporary container for measuring
        const ruler = document.createElement("div");
        ruler.style.position = "absolute";
        ruler.style.visibility = "hidden";
        ruler.style.height = "auto";
        ruler.style.whiteSpace = "nowrap";
        ruler.style.display = "inline-block";
        ruler.style.pointerEvents = "none";
        document.body.appendChild(ruler);

        let maxWidth = 0;

        this.options.forEach(option => {
            const clone = option.cloneNode(true);
            ruler.innerHTML = ""; // Clear previous
            ruler.appendChild(clone);

            const width = ruler.clientWidth;
            if (width > maxWidth) {
                maxWidth = width;
            }
        });

        // Add buffer for padding or dropdown icon
        const borderWidth = 2;

        if (this.selectIsInInput) {
            this.optionDropdown.style.minWidth = `${maxWidth + (2 * borderWidth)}px`;
        } else {
            this.comboEl.style.minWidth = `${maxWidth + (2 * borderWidth)}px`;
        }

        document.body.removeChild(ruler);
    }

    setCurrentOption(options, index) {
        options.forEach((optionEl) => {
            optionEl.classList.remove('form__select-option--current');
        });
        options[index].classList.add('form__select-option--current');
    }

    async fetchSvg(path) {
        try {
            const response = await fetch(path);
            const svgText = await response.text();
            const parser = new DOMParser();
            const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
            const svgElement = svgDoc.documentElement;
            svgElement.setAttribute('aria-hidden', 'true');
            svgElement.setAttribute('focusable', 'false');

            return svgElement;
        } catch (error) {
            console.error('Error fetching SVG:', error);
            return null;
        }
    }

    getSearchString(char) {
        // reset typing timeout and start new timeout
        // this allows us to make multiple-letter matches, like a native select
        if (typeof this.searchTimeout === 'number') {
            window.clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = window.setTimeout(() => {
            this.searchString = '';
        }, 500);

        // add most recent letter to saved search string
        this.searchString += char;
        return this.searchString;
    };

    onLabelClick() {
        this.comboEl.focus();
    };

    onComboBlur(event) {
        // do nothing if relatedTarget is contained within listboxEl
        if (this.listboxEl.contains(event.relatedTarget)) {
            return;
        }

        // select current option and close
        if (this.open) {
            this.updateMenuState(false, false);
        }
    };

    onComboClick() {
        this.updateMenuState(!this.open, false);
    };

    onComboKeyDown(event) {
        const {key} = event;
        const max = this.options.length - 1;

        const action = this.getActionFromKey(event, this.open);

        /* eslint-disable */
        switch (action) {
            case this.selectActions.Last:
            case this.selectActions.First:
                this.updateMenuState(true);
            case this.selectActions.Next:
            case this.selectActions.Previous:
            case this.selectActions.PageUp:
            case this.selectActions.PageDown:
                event.preventDefault();
                return this.onOptionChange(
                    this.getUpdatedIndex(this.activeIndex, max, action)
                );
            case this.selectActions.CloseSelect:
                this.selectOption(this.activeIndex, event);
            case this.selectActions.Close:
                event.preventDefault();
                return this.updateMenuState(false);
            case this.selectActions.Type:
                return this.onComboType(key);
            case this.selectActions.Open:
                event.preventDefault();
                return this.updateMenuState(true);
        }
        /* eslint-enable */
    };

    onComboType(letter) {
        // open the listbox if it is closed
        this.updateMenuState(true);

        // find the index of the first matching option
        const searchString = this.getSearchString(letter);
        const searchIndex = this.getIndexByLetter(
            this.options,
            searchString,
            this.activeIndex + 1
        );

        // if a match was found, go to it
        if (searchIndex >= 0) {
            this.onOptionChange(searchIndex);
        }
        // if no matches, clear the timeout and search string
        else {
            window.clearTimeout(this.searchTimeout);
            this.searchString = '';
        }
    };

    onOptionChange(index) {
        // update state
        this.activeIndex = index;

        // update active option styles
        const options = this.el.querySelectorAll('[role=option]');
        this.setCurrentOption([...options], index);

        // update aria-activedescendant
        this.comboEl.setAttribute('aria-activedescendant', options[index]?.id);

        // ensure the new option is in view
        if (this.isScrollable(this.listboxEl)) {
            this.maintainScrollVisibility(options[index], this.listboxEl);
        }

        // ensure the new option is visible on screen
        // ensure the new option is in view
        if (!this.isElementInView(options[index])) {
            options[index].scrollIntoView({behavior: 'smooth', block: 'nearest'});
        }
    };

    onOptionClick(index) {
        this.onOptionChange(index);
        this.selectOption(index);
        this.updateMenuState(false);
    };

    onOptionMouseDown() {
        // Clicking an option will cause a blur event,
        // but we don't want to perform the default keyboard blur action
        this.ignoreBlur = true;
    };

    selectCountryCodeOption(countryCode) {
        const countryCodeMatch = countryCode.match(/\+\d+/);
        if (countryCodeMatch) {
            const countryCode = countryCodeMatch[0];
            const entries = Object.entries(this.countryCodeMap);

            const matchedEntry = entries.find(([, value]) => countryCode.startsWith(value));

            if (matchedEntry) {
                const matchedIndex = matchedEntry[0];
                this.selectOption(matchedIndex);
                this.parentInput.classList.remove("form__input--error");
            } else {
                this.deselectAll();
                if (this.comboElIcon) {
                    const iconPath = this.comboElIcon.dataset.iconPath + this.iconNotFound + ".svg";

                    this.fetchSvg(iconPath).then(svg => {
                        if (svg) {
                            const iconEl = this.comboElIcon.querySelector(".icon");
                            iconEl.innerHTML = ""; // optional: clear existing content
                            iconEl.appendChild(svg);
                        }
                    });
                }
                this.parentInput.classList.add("form__input--error");
            }
        }
    }

    appendCountryCode(selectedTextContent) {
        const countryCodeMatch = selectedTextContent.match(/\+\d+/);
        if (countryCodeMatch) {
            const countryCode = countryCodeMatch[0];

            const countryCodeValues = Object.values(this.countryCodeMap);
            if (countryCodeValues.includes(countryCode)) {
                const currentValue = this.parentInputEl.value.trim();
                if (currentValue === '') {
                    // Input empty → set to new country code
                    this.parentInputEl.value = countryCode;
                } else {
                    // Check if current value starts with any code in array
                    const matchedCode = Object.values(this.countryCodeMap).find(code =>
                        currentValue.startsWith(code)
                    );

                    if (matchedCode) {
                        // Replace the matched starting code with newCountryCode
                        this.parentInputEl.value = countryCode + currentValue.slice(matchedCode.length);
                    } else {
                        this.parentInputEl.value = countryCode + (currentValue.startsWith("+") ? "" : currentValue);
                    }
                }
            }
        }
    }

    deselectAll() {
        const options = this.el.querySelectorAll('[role=option]');
        options.forEach(optionEl => {
            optionEl.setAttribute('aria-selected', 'false');
            optionEl.classList.remove('form__select-option--current'); // remove current styling too
        });

        this.activeIndex = -1;     // no active selection
        this.selectedOption = null;
        this.comboElLabel.innerHTML = '';   // clear displayed label

        if (this.comboElIcon) {
            // Optionally reset icon to default or empty
            const iconEl = this.comboElIcon.querySelector(".icon");
            iconEl.innerHTML = "";
        }

        this.hiddenInput.value = '';  // clear hidden input value
    }

    selectOption(index) {
        // update aria-selected
        const options = this.el.querySelectorAll('[role=option]');
        const selected = options[index];

        if (!selected) return;
        if (selected.tagName.toLowerCase() === "a") {
            const href = selected.getAttribute('href');
            const target = selected.getAttribute('target');
            if (href) {
                if (target === '_blank') {
                    window.open(href, '_blank', 'noopener'); // add 'noopener' for security
                } else {
                    location.href = href;
                }
            }
        } else {
            // update state
            this.activeIndex = index;

            // update displayed value
            if (this.comboElIcon) {
                const iconPath = this.comboElIcon.dataset.iconPath + selected.dataset.iconName + ".svg";

                this.fetchSvg(iconPath).then(svg => {
                    if (svg) {
                        const iconEl = this.comboElIcon.querySelector(".icon");
                        iconEl.innerHTML = ""; // optional: clear existing content
                        iconEl.appendChild(svg);
                    }
                });
            }

            if (this.selectIsInInput) {
                this.appendCountryCode(selected.textContent);
                this.parentInputEl.focus();
                this.parentInput.classList.remove("form__input--error");
            }
            this.comboElLabel.innerHTML = selected.textContent;
            [...options].forEach((optionEl) => {
                optionEl.setAttribute('aria-selected', 'false');
            });
            options[index].setAttribute('aria-selected', 'true');
            this.hiddenInput.value = options[index].dataset.value;

            if (index === 0) {
                this.setCurrentOption([...options], 1);
                this.activeIndex = 1;
            } else {
                this.setCurrentOption([...options], 0);
                this.activeIndex = 0;
            }
        }
    };

    updateMenuState(open, callFocus = true) {
        if (this.open === open) {
            return;
        }

        // update state
        this.open = open;

        // update aria-expanded and styles
        this.comboEl.setAttribute('aria-expanded', `${open}`);
        open ? this.el.classList.add('form__select--open') : this.el.classList.remove('form__select--open');

        // update activedescendant
        const options = this.el.querySelectorAll('[role=option]');
        const activeID = open ? options[this.activeIndex]?.id : '';
        this.comboEl.setAttribute('aria-activedescendant', activeID);

        if (open) {
            this.updateListboxPosition();
        }

        if (activeID === '' && !this.isElementInView(this.comboEl)) {
            this.comboEl.scrollIntoView({behavior: 'smooth', block: 'nearest'});
        }

        // move focus back to the combobox, if needed
        callFocus && this.comboEl.focus();
    };

    // filter an array of options against an input string
    // returns an array of options that begin with the filter string, case-independent
    filterOptions(options = [], filter, exclude = []) {
        return options.filter((option) => {
            const matches = option.toLowerCase().indexOf(filter.toLowerCase()) === 0;
            return matches && exclude.indexOf(option) < 0;
        });
    }

    // map a key press to an action
    getActionFromKey(event, menuOpen) {
        const {key, altKey, ctrlKey, metaKey} = event;
        const openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' ']; // all keys that will do the default open action
        // handle opening when closed
        if (!menuOpen && openKeys.includes(key)) {
            return this.selectActions.Open;
        }

        // home and end move the selected option when open or closed
        if (key === 'Home') {
            return this.selectActions.First;
        }
        if (key === 'End') {
            return this.selectActions.Last;
        }

        // handle typing characters when open or closed
        if (
            key === 'Backspace' ||
            key === 'Clear' ||
            (key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey)
        ) {
            return this.selectActions.Type;
        }

        // handle keys when open
        if (menuOpen) {
            if (key === 'ArrowUp' && altKey) {
                return this.selectActions.CloseSelect;
            } else if (key === 'ArrowDown' && !altKey) {
                return this.selectActions.Next;
            } else if (key === 'ArrowUp') {
                return this.selectActions.Previous;
            } else if (key === 'PageUp') {
                return this.selectActions.PageUp;
            } else if (key === 'PageDown') {
                return this.selectActions.PageDown;
            } else if (key === 'Escape') {
                return this.selectActions.Close;
            } else if (key === 'Enter' || key === ' ') {
                return this.selectActions.CloseSelect;
            }
        }
    }

    // return the index of an option from an array of options, based on a search string
    // if the filter is multiple iterations of the same letter (e.g "aaa"), then cycle through first-letter matches
    getIndexByLetter(options, filter, startIndex = 0) {
        const orderedOptions = [
            ...options.slice(startIndex),
            ...options.slice(0, startIndex),
        ];
        const firstMatch = this.filterOptions(orderedOptions, filter)[0];
        const allSameLetter = (array) => array.every((letter) => letter === array[0]);

        // first check if there is an exact match for the typed string
        if (firstMatch) {
            return options.indexOf(firstMatch);
        }

        // if the same letter is being repeated, cycle through first-letter matches
        else if (allSameLetter(filter.split(''))) {
            const matches = this.filterOptions(orderedOptions, filter[0]);
            return options.indexOf(matches[0]);
        }

        // if no matches, return -1
        else {
            return -1;
        }
    }

    // get an updated option index after performing an action
    getUpdatedIndex(currentIndex, maxIndex, action) {
        const pageSize = 10;

        const isSelected = index =>
            this.options[index] &&
            this.options[index].getAttribute('aria-selected') === 'true';

        switch (action) {
            case this.selectActions.First:
                for (let i = 0; i <= maxIndex; i++) {
                    if (!isSelected(i)) return i;
                }
                break;

            case this.selectActions.Last:
                for (let i = maxIndex; i >= 0; i--) {
                    if (!isSelected(i)) return i;
                }
                break;

            case this.selectActions.Next:
                for (let i = currentIndex + 1; i <= maxIndex; i++) {
                    if (!isSelected(i)) return i;
                }
                break;

            case this.selectActions.Previous:
                for (let i = currentIndex - 1; i >= 0; i--) {
                    if (!isSelected(i)) return i;
                }
                break;

            case this.selectActions.PageDown:
                for (let i = Math.min(currentIndex + pageSize, maxIndex); i <= maxIndex; i++) {
                    if (!isSelected(i)) return i;
                }
                break;

            case this.selectActions.PageUp:
                for (let i = Math.max(currentIndex - pageSize, 0); i >= 0; i--) {
                    if (!isSelected(i)) return i;
                }
                break;

            default:
                return currentIndex;
        }

        // If nothing found, stay on current
        return currentIndex;
    }

    // check if element is visible in browser view port
    isElementInView(element) {
        const bounding = element.getBoundingClientRect();

        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <=
            (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    // check if an element is currently scrollable
    isScrollable(element) {
        return element && element.clientHeight < element.scrollHeight;
    }

    // ensure a given child element is within the parent's visible scroll area
    // if the child is not visible, scroll the parent
    maintainScrollVisibility(activeElement, scrollParent) {
        const {offsetHeight, offsetTop} = activeElement;
        const {offsetHeight: parentOffsetHeight, scrollTop} = scrollParent;

        const isAbove = offsetTop < scrollTop;
        const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;

        if (isAbove) {
            scrollParent.scrollTo(0, offsetTop);
        } else if (isBelow) {
            scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
        }
    }

    updateListboxPosition() {
        const comboRect = this.comboEl.getBoundingClientRect();
        const listboxHeight = this.listboxEl.offsetHeight;
        const spaceBelow = window.innerHeight - comboRect.bottom;
        const spaceAbove = comboRect.top;

        // Reset previous state
        this.el.classList.remove('form__select--drop-up');

        if (spaceBelow < listboxHeight && spaceAbove > listboxHeight) {
            // Not enough space below, but enough above: open upward
            this.el.classList.add('form__select--drop-up');
        }
    }
}

export default Select;